import { ApAgingInvoiceSortField, type ApAgingTotals } from "./types/apAgingReport"

import { ApAgingBucket, InvoiceStatus, SortingOrder } from "@/graphql/codegen/graphql"

// AK-6964 AC2: Only these invoice statuses are part of the report.
export const AP_AGING_ELIGIBLE_STATUSES = [
  InvoiceStatus.Approved,
  InvoiceStatus.PendingApproval,
  InvoiceStatus.NotApproved,
] as const

export type ApAgingStatus = (typeof AP_AGING_ELIGIBLE_STATUSES)[number]

// AK-6964 AC2: Approved is the only status selected when the report first opens.
export const AP_AGING_DEFAULT_STATUSES: ApAgingStatus[] = [InvoiceStatus.Approved]

export const AP_AGING_BUCKET_TO_LABEL: Record<ApAgingBucket, string> = {
  [ApAgingBucket.Current]: "Current",
  [ApAgingBucket.Days_1_30]: "1-30 Days",
  [ApAgingBucket.Days_31_60]: "31-60 Days",
  [ApAgingBucket.Days_61_90]: "61-90 Days",
  [ApAgingBucket.Over_90]: "Over 90 Days",
}

// AK-6964 AC7: The invoices of an expanded vendor are sorted by Days Overdue, highest first, unless the user sorts.
export const AP_AGING_DEFAULT_INVOICE_SORT_FIELD = ApAgingInvoiceSortField.DaysOverdue
export const AP_AGING_DEFAULT_INVOICE_SORT_ORDER = SortingOrder.Desc

export const AP_AGING_SEARCH_MAX_LENGTH = 200

// AK-6964 AC4, AC5: The summary cards and the vendor table columns share the same aging buckets, then the total.
export const AP_AGING_TOTALS_COLUMNS: { key: keyof ApAgingTotals; label: string }[] = [
  { key: "current", label: AP_AGING_BUCKET_TO_LABEL[ApAgingBucket.Current] },
  { key: "days1To30", label: AP_AGING_BUCKET_TO_LABEL[ApAgingBucket.Days_1_30] },
  { key: "days31To60", label: AP_AGING_BUCKET_TO_LABEL[ApAgingBucket.Days_31_60] },
  { key: "days61To90", label: AP_AGING_BUCKET_TO_LABEL[ApAgingBucket.Days_61_90] },
  { key: "over90", label: AP_AGING_BUCKET_TO_LABEL[ApAgingBucket.Over_90] },
  { key: "total", label: "Total" },
]
